"use strict";
// Do not edit directly
// Generated on Fri, 19 May 2023 23:23:23 GMT
exports.__esModule = true;
exports["default"] = {
    colorWhite: "#ffffff",
    colorBlack: "#040404",
    colorBlue: "#0265dc",
    colorBlueGrey: "#8c9ca5",
    colorOrange: "#b14c00",
    colorYellow: "#ffc902",
    colorGreen: "#007a4d",
    colorCyan: "#08bfdf",
    colorPurple: "#6954c0",
    colorRed: "#f94d32",
    colorMagenta: "#b52d88",
    defaultBorderRadius: "3px",
    circularRadius: "50%",
    pillRadius: "500em",
    opacityHover: ".8",
    opacityDisable: ".6",
    borderRadius0: "0",
    borderRadius1: "3px",
    borderRadius2: "6px",
    borderRadiusPill: "500em",
    borderRadiusCircular: "50%",
    breakpointMobile: "320px",
    breakpointMobileLarge: "576px",
    breakpointTablet: "768px",
    breakpointDesktop: "992px",
    breakpointLarge: "1200px",
    breakpointWidescreen: "1920px",
    colorBlue100: "#e0f2ff",
    colorBlue200: "#b5deff",
    colorBlue300: "#78bbfa",
    colorBlue400: "#3892f3",
    colorBlue500: "#0265dc",
    colorBlue600: "#004491",
    colorNeutral0: "#ffffff",
    colorNeutral10: "#fcfcfc",
    colorNeutral20: "#fafafa",
    colorNeutral30: "#f7f7f7",
    colorNeutral40: "#f5f5f5",
    colorNeutral50: "#eeeeee",
    colorNeutral60: "#dfe0e1",
    colorNeutral70: "#bcbcbd",
    colorNeutral80: "#949596",
    colorNeutral90: "#737475",
    colorNeutral100: "#606162",
    colorNeutral200: "#444445",
    colorNeutral300: "#2d2e31",
    colorNeutral400: "#141414",
    colorNeutral500: "#040404",
    colorBlueGrey100: "#eaeff2",
    colorBlueGrey200: "#d0d8dd",
    colorBlueGrey300: "#b4c1c8",
    colorBlueGrey400: "#8c9ca5",
    colorBlueGrey500: "#6a7a85",
    colorBlueGrey600: "#576671",
    colorOrange100: "#ffeccc",
    colorOrange200: "#fdd291",
    colorOrange300: "#ffa037",
    colorOrange400: "#e46f00",
    colorOrange500: "#b14c00",
    colorOrange600: "#7a2f00",
    colorYellow100: "#fff9e2",
    colorYellow200: "#fff0b1",
    colorYellow300: "#ffe278",
    colorYellow400: "#ffc902",
    colorYellow500: "#ffbe00",
    colorYellow600: "#de9500",
    colorGreen100: "#cef8e0",
    colorGreen200: "#89ecbc",
    colorGreen300: "#49cc93",
    colorGreen400: "#15a46e",
    colorGreen500: "#007a4d",
    colorGreen600: "#005132",
    colorCyan100: "#e3fcff",
    colorCyan200: "#b1f3fa",
    colorCyan300: "#13ceea",
    colorCyan400: "#08bfdf",
    colorCyan500: "#0ca5c0",
    colorCyan600: "#038299",
    colorPurple100: "#f1edff",
    colorPurple200: "#c1b6f2",
    colorPurple300: "#8772e5",
    colorPurple400: "#6954c0",
    colorPurple500: "#4f3a9e",
    colorPurple600: "#422799",
    colorRed100: "#ffece9",
    colorRed200: "#ffb2a0",
    colorRed300: "#ff745f",
    colorRed400: "#f94d32",
    colorRed500: "#e13212",
    colorRed600: "#bf2a00",
    colorMagenta100: "#fbeaf5",
    colorMagenta200: "#faafe2",
    colorMagenta300: "#d949a9",
    colorMagenta400: "#b52d88",
    colorMagenta500: "#982071",
    colorMagenta600: "#7d165b",
    durationNone: "0ms",
    durationFast: "100ms",
    durationStandard: "200ms",
    durationSlow: "300ms",
    easingStandard: "cubic-bezier(.4, 0, .2, 1)",
    easingIn: "cubic-bezier(.4, 0, 1, 1)",
    easingOut: "cubic-bezier(0, 0, .4, 1)",
    easingInOut: "cubic-bezier(.4, 0, .6, 1)",
    fontWeightRegular: "400",
    fontWeightSemibold: "600",
    fontWeightBold: "700",
    opacityHovered: ".8",
    opacityDisabled: ".6",
    opacityPlaceholder: ".4",
    shadowSize0: "0 0 0",
    shadowSize1: "0 1px 2px",
    shadowSize2: "0 2px 8px",
    shadowSize3: "0 8px 24px",
    shadowColor: "rgba(20, 20, 20, .1)",
    shadowColorActive: "rgba(34, 112, 238, .2)",
    shadowColorError: "rgba(230, 55, 23, .2)",
    shadowFocus: "0 0 0 3px var(--colorsFocusRingPrimary, rgba(169, 209, 255, 1))",
    shadowFocusInset: "inset 0 0 0 3px var(--colorsFocusRingPrimary, rgba(169, 209, 255, 1))",
    spacing0: "0",
    spacing1: "8px",
    spacing2: "16px",
    spacing3: "24px",
    spacing4: "32px",
    spacing5: "48px",
    spacing6: "64px",
    spacing7: "96px",
    spacing8: "128px",
    spacingHalf: "4px",
    typescale0: "10px",
    typescale1: "12px",
    typescale2: "14px",
    typescale3: "16px",
    typescale4: "20px",
    typescale5: "26px",
    typescale6: "32px",
    typescale7: "41px",
    baseFontSize: "16px",
    baseLineHeight: "1.5",
    baseFontFamily: "'Nunito Sans', sans-serif",
    displayFontFamily: "'Sofia Pro', SofiaPro, sans-serif",
    displayLineHeight: "1.25",
    zIndexNotification: "1200",
    zIndexOverlay: "1100",
    zIndexGuideHelp: "999",
    zIndexGlobalNav: "990",
    zIndexPopover: "800",
    zIndexModal: "1100",
    zIndexDrawer: "1100"
};
